import { useAdoptedTools } from "../../../marketplace";
import { SessionPaymentSummary } from "../../../payments";

/**
 * What was charged for this session, but only for therapists who have adopted
 * Payments.
 *
 * The adoption check sits here rather than in the card — the same split
 * `HomeNextSession` and `HomePendingPayments` use — so the card stays a plain
 * presentation of payments data and its query never runs, and never 403s, for
 * a therapist without the tool.
 */
export default function SessionPayments({ sessionId }: { sessionId: string }) {
    const { data: tools, isLoading } = useAdoptedTools();

    if (isLoading || !tools) return null;
    if (!tools.some((tool) => tool.slug === "payments")) return null;

    return <SessionPaymentSummary sessionId={sessionId} />;
}
